import type { StringGUID } from "@pdfking/tfunc"
import { UUID } from "@pdfking/tfunc"
import { GuidToString } from "@pdfking/tfunc"

export default (): StringGUID => GuidToString(UUID())
